import { alpha, styled } from '@mui/material/styles';
import { PickersTextField as MuiPickersTxtField } from '@mui/x-date-pickers/PickersTextField';

const PickersTextField = styled(MuiPickersTxtField)(({ theme }) => ({
  lineHeight: '1.375em',
  borderRadius: 4,

  '& .MuiPickersOutlinedInput-root': {
    padding: '0 12px',

    '&:hover .MuiPickersOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
    },
    '& .MuiPickersOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.divider}`,
      fontSize: '1rem',
      lineHeight: theme.input.lineHeight,
      padding: '7px 12px',
      transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
      '&:focus': {
        boxShadow: `${alpha(theme.palette.primary.main, 0.35)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
      },
      '&:hover': {
        border: 'none',
      },
    },
    '& .MuiPickersSectionList-root': {
      padding: '7px 0',
    },

    '&.Mui-focused': {
      '& .MuiPickersOutlinedInput-notchedOutline': {
        boxShadow: `${alpha(theme.palette.primary.main, 0.35)} 0 0 0 2px`,
        borderColor: theme.palette.primary.main,
        borderWidth: '1px',
      },
      '&.Mui-error': {
        '& .MuiPickersOutlinedInput-notchedOutline': {
          borderColor: theme.palette.error.main,
          boxShadow: `${alpha(theme.palette.error.main, 0.35)} 0 0 0 2px`,
        },
      },
    },
  },
}));

export default PickersTextField;
